module.exports = __webpack_public_path__ + "img/emoji_38.ab14b731.png";